/**
 * Lê o estado vivo do desconto automático (section API, sem cache)
 * e liga/desliga tag + preço na hora.
 */
(function () {
  var SECTION = 'andrade-vitrine-state';
  var lastKey = '';

  function parseState(html) {
    if (!html) return null;
    var doc = document.implementation.createHTMLDocument('');
    doc.body.innerHTML = html;
    var el = doc.querySelector('#andrade-vitrine-state-json');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function liveState() {
    var el = document.getElementById('andrade-vitrine-state-json');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function isActive(state, collections) {
    if (!state) return false;
    var st = String(state.status || '').toUpperCase();
    if (st === 'INACTIVE' || st === 'EXPIRED' || st === 'DISABLED') return false;
    var pct = Number(state.percent || 0);
    if (!(pct > 0 && pct < 100)) return false;
    if (!state.label) return false;
    var now = Date.now();
    if (state.starts_at) {
      var start = Date.parse(state.starts_at);
      if (start && now < start) return false;
    }
    if (state.ends_at) {
      var end = Date.parse(state.ends_at);
      if (end && now >= end) return false;
    }
    var handles = String(state.handles || '')
      .toLowerCase()
      .replace(/\s+/g, '');
    if (!handles || handles === '*' || handles === 'all' || handles === 'todos') return true;
    var list = handles.split(',').filter(Boolean);
    var cols = String(collections || '')
      .toLowerCase()
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
    return list.some(function (h) {
      return cols.indexOf(h) !== -1;
    });
  }

  function windowOpen(item) {
    var now = Date.now();
    if (item.starts_at) {
      var start = Date.parse(item.starts_at);
      if (start && now < start) return false;
    }
    if (item.ends_at) {
      var end = Date.parse(item.ends_at);
      if (end && now >= end) return false;
    }
    return true;
  }

  function matchesTarget(item, collections, productHandle) {
    var handles = String(item.handles || '')
      .toLowerCase()
      .replace(/\s+/g, '');
    var products = String(item.products || '')
      .toLowerCase()
      .replace(/\s+/g, '');
    if ((!handles || handles === '*' || handles === 'all' || handles === 'todos') && !products) return true;
    var cols = String(collections || '')
      .toLowerCase()
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
    if (handles && handles !== '*' && handles !== 'all' && handles !== 'todos') {
      if (
        handles.split(',').filter(Boolean).some(function (h) {
          return cols.indexOf(h) !== -1;
        })
      ) {
        return true;
      }
    }
    if (products && productHandle) {
      if (products.split(',').filter(Boolean).indexOf(String(productHandle).toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function pickDiscount(state, el) {
    if (!state || !el) return null;
    var collections = el.getAttribute('data-product-collections') || '';
    var productHandle = el.getAttribute('data-product-handle') || '';
    if (state.synced_at) {
      var list = Array.isArray(state.discounts) ? state.discounts : [];
      var best = null;
      list.forEach(function (item) {
        var pct = Number(item.percent || 0);
        if (!(pct > 0 && pct < 100) || !item.label) return;
        if (!windowOpen(item) || !matchesTarget(item, collections, productHandle)) return;
        if (!best || pct > Number(best.percent)) best = item;
      });
      return best;
    }
    return isActive(state, collections) ? state : null;
  }

  function applyState(state) {
    if (!state) return;
    var key = JSON.stringify(state);
    if (key === lastKey) return;
    lastKey = key;
    var pix = Number(state.pix_percent || 0);
    if (!Number.isFinite(pix) || pix < 0) pix = 0;
    document.querySelectorAll('[data-md-pdp]').forEach(function (root) {
      var match = pickDiscount(state, root);
      var on = Boolean(match);
      root.dataset.autoDiscountPercent = on ? String(match.percent) : '0';
      root.dataset.autoDiscountLabel = on ? match.label || '' : '';
      root.dataset.promoStart = on ? match.starts_at || '' : '';
      root.dataset.promoEnd = on ? match.ends_at || '' : '';
      root.dataset.pixDiscount = String(pix);
      if (root._andradePdp) {
        root._andradePdp.pixDiscount = pix / 100;
        if (typeof root._andradePdp.refreshDisplayedPrices === 'function') {
          root._andradePdp.refreshDisplayedPrices();
        }
      }
      var bar = root.querySelector('[data-md-promo-bar]');
      if (bar) {
        var showBar = Boolean(on && match.starts_at && match.ends_at);
        bar.hidden = !showBar;
        bar.classList.toggle('hidden', !showBar);
      }
      var name = root.querySelector('[data-md-promo-name]');
      var campaign = name ? (name.getAttribute('data-andrade-promo-campaign') || '').trim() : '';
      var line = root.querySelector('[data-md-promo-line]');
      if (line) line.classList.toggle('hidden', !on && !campaign);
      if (name) {
        name.textContent = campaign;
        name.hidden = !campaign;
        var dash = root.querySelector('.md-pdp__promo-dash');
        if (dash) dash.hidden = !on || !campaign;
      }
    });

    document.querySelectorAll('[data-andrade-pricing]').forEach(function (meta) {
      var match = pickDiscount(state, meta);
      var on = Boolean(match);
      meta.dataset.autoDiscountPercent = on ? String(match.percent) : '0';
      meta.dataset.autoDiscountLabel = on ? match.label || '' : '';
      meta.dataset.pixPercent = String(pix);
      var tag = meta.closest('.ml-card-info');
      if (tag) {
        var promo = tag.querySelector('.ml-card-info__promo-tag');
        if (promo) {
          var campaign = (promo.getAttribute('data-andrade-promo-campaign') || '').trim();
          promo.textContent = campaign;
          promo.hidden = !campaign;
        }
      }
    });

    document.dispatchEvent(new CustomEvent('andrade:vitrine', { detail: state, bubbles: true }));
    if (window.AndradeCardPricing && typeof window.AndradeCardPricing.refreshAll === 'function') {
      window.AndradeCardPricing.refreshAll();
    }
  }

  function refresh() {
    if (refresh.inFlight) return;
    refresh.inFlight = true;
    var url = '/?sections=' + encodeURIComponent(SECTION) + '&andrade_vitrine=' + Date.now();
    fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        var html = json && json[SECTION];
        var state = parseState(html) || liveState();
        applyState(state);
      })
      .catch(function () {
        applyState(liveState());
      })
      .then(function () {
        refresh.inFlight = false;
      });
  }

  applyState(liveState());
  refresh();
  setInterval(refresh, 8000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('pageshow', refresh);
})();
